import { inject, Injectable } from '@angular/core'

import { LoggerService } from '../logger/logger.service'
import { SHOW_TRANSLATION_KEYS } from './show-translation-keys.token'
import { TRANSLATIONS } from './translations.token'

export type TranslateArgs = Record<string, string | number | undefined | null> | undefined | null
export type KeyGetter = (key: string, args?: TranslateArgs) => string

@Injectable()
export class TranslatorService {
  readonly get: KeyGetter

  private readonly translations = inject(TRANSLATIONS)
  private readonly logger = inject(LoggerService).getInstance('TranslatorService')

  constructor() {
    this.get = inject(SHOW_TRANSLATION_KEYS) ? this._showKey : this._get
  }

  private readonly _get: KeyGetter = (key, args) => {
    const value = this.translations[key]
    if (!value) {
      this.logger.error(`Translation key '${key}' was used but is not available`)
      return `???${key}???`
    }
    return args ? Object.entries(args || {}).reduce((u, [k, v]) => u.replace(`{${k}}`, <string>v), value) : value
  }

  private readonly _showKey: KeyGetter = (key, args) => {
    return args ? `${key} :: ${Object.keys(args).join(', ')}` : key
  }
}
